import Lenis from 'lenis'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Scroller {
  constructor() {
    this.documentScroller()
  }

  documentScroller() {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 2,
    })

    window.lenis = lenis

    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf.bind(this))
    }

    requestAnimationFrame(raf.bind(this))
  }
}

export default Scroller
